import * as authentication from "../actions/authentication";
import * as modal from "../actions/modal.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        modal: null,
        dropDown: [],
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case modal.SET_MODAL:
        return state.merge({
            modal: action.modal,
        });
    case modal.ADD_DROPDOWN:
        return state.merge({
            dropDown: state.dropDown.concat(action.dropDown),
        });
    case modal.POP_DROPDOWN:
        return state.merge({
            dropDown: state.dropDown.filter( (item, index) => index+1!==state.dropDown.length ),
        });
    case modal.CLEAR_MODAL_DROPDOWNS:
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}